import React from "react";
import { Link } from "react-router-dom";
import MultiStepSignupFormWithRole from "@/components/auth/MultiStepSignupFormWithRole";

const MultiStepSignupWithRoleDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-sauna-beige">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-sauna-navy mb-4">
            Multi-Step Signup with Role Selection
          </h1>
          <p className="text-sauna-navy/80 max-w-2xl mx-auto">
            This enhanced version includes user/operator selection as the first step. 
            Choose your account type and follow the guided signup process with different 
            steps based on your selection.
          </p>
          <div className="mt-4 space-x-4">
            <Link 
              to="/" 
              className="text-sauna-orange hover:underline font-medium"
            >
              ← Back to Home
            </Link>
            <Link 
              to="/multi-step-signup-demo" 
              className="text-sauna-orange hover:underline font-medium"
            >
              View Basic Demo
            </Link>
          </div>
        </div>
        
        <div className="bg-sauna-orange/10 p-6 rounded-lg border border-sauna-orange/20 max-w-2xl mx-auto text-center">
          <h2 className="text-xl font-semibold text-sauna-navy mb-2">
            Enhanced Multi-Step Signup Coming Soon!
          </h2>
          <p className="text-sauna-navy/80 mb-4">
            The enhanced version with role selection is currently in development. 
            For now, you can try the basic multi-step signup demo.
          </p>
          <Link 
            to="/multi-step-signup-demo" 
            className="inline-block bg-sauna-orange text-white px-6 py-2 rounded-lg hover:bg-sauna-orange/90 transition-colors"
          >
            Try Basic Multi-Step Demo
          </Link>
        </div>
        
        <MultiStepSignupFormWithRole />
      </div>
    </div>
  );
};

export default MultiStepSignupWithRoleDemo; 